/* @flow strict */

import * as React from 'react';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import SelfCheckinColorPicker from './colorPicker';
import Panel from './panel';
import { POST } from '/client/src/api';
import SaveBtn from './saveBtn';
import Loader from '/client/src/components/Loader';
import { timeerOffModal } from '/client/src/constants/';
import CssPinner from '/client/src/components/csspinner';
import './index.scss';

class SelfCheckIn extends React.Component {
  static contextType = DefaultContainerContext;

  constructor(props) {
    super(props);

    this.state = {
      wlkmMsg: '',
      coverImgCheckboxStatus: true,
      coverLogoCheckboxStatus: true,
      coverImg: null,
      coverLogo: null,
      coverImgUrl: null,
      coverLogoUrl: null,
      colorPicker: '#003a71',
      durandalIsLoad: false,
      isSaveError: false
    };
  }

  handleLoaded = (error: Error, { data }: any) => {
    const title = _.get(data, 'result.title', '');
    const color = _.get(data, 'result.color', '003a71');
    const bannerimagepath = _.get(data, 'result.bannerimagepath', null);
    const logoimagepath = _.get(data, 'result.logoimagepath', null);
    const showbanner = _.get(data, 'result.showbanner', true);
    const showlogo = _.get(data, 'result.showlogo', true);

    this.setState({
      wlkmMsg: title,
      colorPicker: `#${color}`,
      coverImgUrl: bannerimagepath,
      coverLogoUrl: logoimagepath,
      coverImgCheckboxStatus: showbanner,
      coverLogoCheckboxStatus: showlogo
    });
  }

  handleSetImages = (name, file) => {
    if (!!file) {
      this.setState({
        [name]: file[0],
        [`${name}Url`]: URL.createObjectURL(file[0])
      });
    }
  }

  handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState({
      [name]: value,
      [`inValid${name}`]: false
    });

    if (!_.size(value)) {
      this.setState({
        [`inValid${name}`]: true
      });
    }
  }

  handleChangeCheckboxes = (e) => {
    const name = e.name;
    const value = e.checked;

    this.setState({
      [name]: value
    });
  }

  handleChangeColorPicker = (color) => {
    this.setState({
      colorPicker: color
    });
  }

  handleShowModalError = (errorMsg) => {
    this.context.handleShowSystemDialog(true, {
      systemDialogType: 'error',
      systemDialogTitle: 'Error',
      systemDialogContent: errorMsg
    });
  }

  handleCloseModalError = () => {
    this.setState({
      isSaveError: false
    });
  }

  handleSave = async () => {
    const { match: { params: { eventId } } } = this.props;

    CssPinner(document.body, true);

    try {
      const {
        colorPicker,
        coverImg,
        coverLogo,
        wlkmMsg,
        coverImgCheckboxStatus,
        coverLogoCheckboxStatus
      } = this.state;
      const data = {
        color: colorPicker.slice(1),
        bannerImageFile: coverImg ? coverImg : null,
        logoImageFile: coverLogo ? coverLogo : null,
        title: wlkmMsg
      };
      const formData = new FormData();

      formData.append('eventId', eventId);
      formData.append('bannerImageFile', coverImgCheckboxStatus ? data.bannerImageFile : null);
      formData.append('logoImageFile', coverLogoCheckboxStatus ? data.logoImageFile : null);
      formData.append('color', data.color || '#003a71');
      formData.append('title', data.title);
      formData.append('ShowBanner', Boolean(coverImgCheckboxStatus));
      formData.append('ShowLogo', Boolean(coverLogoCheckboxStatus));
      formData.append('EventId', eventId);

      await POST(`/api/v1/1/selfcheckin/${eventId}/files`, formData, null, 'multipart/form-data');

      CssPinner(document.body, false);

      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Operation successfull'
      });

      setTimeout(() => {
        this.context.handleShowSystemDialog(false);
      }, timeerOffModal);
    } catch (e) {
      CssPinner(document.body, false);

      const errorMsg =  _.get(e, 'data.error.message', 'error');

      this.handleShowModalError(errorMsg);
    }
  }

  render = (): React.Element => {
    const {
      wlkmMsg,
      coverImgCheckboxStatus,
      coverLogoCheckboxStatus,
      coverImgUrl,
      coverLogoUrl,
      inValidwlkmMsg
    } = this.state;
    const { eventId } = this.props;

    return (
      <Loader
        url={`/api/v1/1/selfcheckin/${eventId}`}
        onLoaded={this.handleLoaded}
      >
        <div className="selfCheckinPage">
          <div className="panel panel-default panel-page panel-self-checkin no-border">
            <div className="navbar-page-toolbar customers-navbar send-mail-navbar">
              <div className="container-fluid" style={{ height: '50px' }}>
                <div className="navbar-header" style={{ color: '#fff' }}>
                  <div className="navbar-brand">Self check-in settings</div>
                </div>
              </div>
            </div>

            <div className="panel-body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-8 col-lg-6">
                    <div className="form-group" style={{ position: 'relative' }}>
                      <label>Self check-in welcome message</label>
                      <input
                        type="text"
                        className={`${inValidwlkmMsg ? 'is-error' : ''} form-control`}
                        value={wlkmMsg}
                        name="wlkmMsg"
                        onChange={(e) => this.handleChangeInput(e)}
                      />

                      <span className="validationMessage">
                        {inValidwlkmMsg ? "Field can't be empty" : ''}
                      </span>
                    </div>

                    <SelfCheckinColorPicker
                      handleChangeComplete={this.handleChangeColorPicker}
                      selectedColor={this.state.colorPicker}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Panel
            checkboxStatus={coverImgCheckboxStatus}
            name='coverImgCheckboxStatus'
            id='coverImg'
            title='Cover image'
            imgUrl={coverImgUrl}
            handleChangeCheckboxes={this.handleChangeCheckboxes}
            handleSetImages={this.handleSetImages}
          />

          <Panel
            checkboxStatus={coverLogoCheckboxStatus}
            name='coverLogoCheckboxStatus'
            id='coverLogo'
            title='Cover logo'
            handleChangeCheckboxes={this.handleChangeCheckboxes}
            imgUrl={coverLogoUrl}
            handleSetImages={this.handleSetImages}
          />
      </div>

      <SaveBtn handleSave={this.handleSave} />
      </Loader>
    );
  }
}

export default withRouter(SelfCheckIn);
